<template>
  <FieldWrapper
    :label="label"
    :state="state"
    :configs="configs"
  >
    <div class="column full-width custom-field-date">
      <div class="col">
        <q-input
          v-model="text"
          dense
          outlined
          bg-color="white"
          :error="!isValid"
          :error-message="errorMessage"
          :readonly="isFieldDisabled"
        />
      </div>
    </div>
  </FieldWrapper>
</template>

<script>
import FieldWrapper from './FieldWrapper'

export default {
  components: {
    FieldWrapper
  },

  props: {
    value: {},
    state: {},
    label: {},
    configs: {},
    errorMessage: {},
    disabled: {},

    isAnonymous: {
      type: Boolean,
      default: false
    },

    isValid: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      text: forceStr(this.value)
    }
  },

  computed: {
    placeholder () {
      return this.configs?.placeholder
    },

    isFieldDisabled () {
      return this.disabled || this.isAnonymous
    }
  },

  watch: {
    text (text) {
      if (isEqual(text, this.value)) return
      this.$emit('input', forceStr(text))
    },

    value (value) {
      if (isEqual(this.text, value)) return
      this.text = forceStr(value)
    }
  }
}

const forceStr = (val) => String(val || '').trim()

const isEqual = (source, target) => {
  const val1 = forceStr(source)
  const val2 = forceStr(target)
  return val1 === val2
}

</script>
